import React from 'react'
import { TextField, Box } from '@mui/material'
import { useTranslation } from 'react-i18next'

type NameFieldsProps = {
  formValues: {
    firstName: string
    lastName: string
  }
  errors: {
    firstName: string
    lastName: string
  }
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  handleBlur: (
    e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void
  size?: 'small' | 'medium'
}

const NameFields: React.FC<NameFieldsProps> = ({
  formValues,
  errors,
  handleInputChange,
  handleBlur,
  size = 'small'
}) => {
  const { t } = useTranslation()
  return (
    <Box display='flex' gap={2}>
      <TextField
        label={t('contactUs.firstName')}
        name='firstName'
        value={formValues.firstName}
        onChange={handleInputChange}
        onBlur={handleBlur}
        placeholder={t('addressFields.placeholders.required')}
        fullWidth
        margin='dense'
        variant='outlined'
        required
        error={Boolean(errors.firstName)}
        helperText={errors.firstName}
        inputProps={{ maxLength: 20 }}
        size={size as 'small' | 'medium'}
      />

      <TextField
        label={t('contactUs.lastName')}
        name='lastName'
        value={formValues.lastName}
        onChange={handleInputChange}
        onBlur={handleBlur}
        placeholder={t('addressFields.placeholders.required')}
        fullWidth
        margin='dense'
        variant='outlined'
        required
        error={Boolean(errors.lastName)}
        helperText={errors.lastName}
        inputProps={{ maxLength: 20 }}
        size={size as 'small' | 'medium'}
      />
    </Box>
  )
}

export default NameFields
